import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

export const IDLE_TIMEOUT_WARNING_MODAL_KEY = 'IDLE_TIME_WARNING_MODAL_KEY';

interface IdleTimeoutWarningModalProps {
  onRequestClose: () => void;
  onSignOut: () => void;
}

export default function IdleTimeoutWarningModal(props: IdleTimeoutWarningModalProps): JSX.Element {
  return (
    <Modal
      onRequestClose={props.onRequestClose}
      closeable={false}
      closeableOnBackgroundClick={false}
      closeableOnEscapeKey={false}
      title="Your session is about to expire"
      medium={true}
      buttons={[
        {
          text: 'Sign out',
          submit: true,
          asLink: true,
          dataMethod: 'POST',
          href: '/signout',
          style: ButtonStyle.SECONDARY_WHITE,
          onClick: props.onSignOut,
        },
        {
          text: 'Continue',
          cancel: true,
          style: ButtonStyle.SECONDARY,
          onClick: props.onRequestClose,
        },
      ]}
    >
      <p>For security reasons, your session will expire soon due to inactivity.</p>
      <p>Click Continue to stay signed in.</p>
    </Modal>
  );
}
